import React, {useState, useEffect} from 'react'
import {useNavigate} from 'react-router-dom'
import {Menu, Bell, User} from 'lucide-react'
import {getCurrentUser} from '../../services/api'
import {getUnreadCount} from '../../services/Notifications'

interface HeaderProps {
    toggleSidebar: () => void
}

const Header: React.FC<HeaderProps> = ({toggleSidebar}) => {
    const navigate = useNavigate()
    const user = getCurrentUser()
    const [unreadCount, setUnreadCount] = useState(0)

    useEffect(() => {
        fetchUnreadCount()
        const interval = setInterval(fetchUnreadCount, 30000)
        return () => clearInterval(interval)
    }, [])

    const fetchUnreadCount = async () => {
        try {
            const count = await getUnreadCount()
            setUnreadCount(count)
        } catch (error) {
            console.error('Error fetching unread count:', error)
        }
    }

    return (
        <header className="bg-white shadow-sm fixed top-0 left-0 right-0 lg:right-64 z-40">
            <div className="flex items-center justify-between h-16 px-4 lg:px-6">
                <button
                    onClick={toggleSidebar}
                    className="lg:hidden p-2 hover:bg-gray-100 rounded-lg"
                >
                    <Menu className="w-6 h-6" />
                </button>

                <div className="flex-1" />

                <div className="flex items-center gap-4">
                    <button
                        onClick={() => navigate('/notifications')}
                        className="relative hover:bg-gray-100 p-2 rounded-lg transition-colors"
                    >
                        <Bell className="w-5 h-5" />
                        {unreadCount > 0 && (
                            <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 text-white text-xs rounded-full flex items-center justify-center">
                                {unreadCount > 9 ? '9+' : unreadCount}
                            </span>
                        )}
                    </button>

                    <button
                        onClick={() => navigate('/profile')}
                        className="flex items-center gap-2 hover:bg-gray-100 p-2 rounded-lg transition-colors"
                    >
                        <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center text-white">
                            <User className="w-4 h-4" />
                        </div>
                        <span className="hidden sm:block">{user?.username || 'admin'}</span>
                    </button>
                </div>
            </div>
        </header>
    )
}

export default Header